import axios from "axios";
import config from "config.json";
import { getAuthorizationHeader } from "./auth_service";

const qs = require("qs");

export const getGameById = async (id) => {
  let res = await axios.get(
    process.env.REACT_APP_BACKEND_URL + `api/games/${id}?populate=*`,
    getAuthorizationHeader()
  );

  return res.data.data;
};

export const getGames = async (filters = [], sort = []) => {
  let teamIds = JSON.parse(localStorage.getItem("teamIDs")).map((el) => el.id)
  if (teamIds.length === 0) {
    return []
  }

  const query = qs.stringify(
    {
      filters: {
        team: {
          id: {
            $in: teamIds,
          },
        },
        ...filters,
      }, 
    },
    {
      encodeValuesOnly: true, // prettify URL
    }
  );

  let res = await axios.get(
    process.env.REACT_APP_BACKEND_URL + `api/games?${query}&populate=*&${sort}`,
    getAuthorizationHeader()
  );

  return res.data.data;
};

export const createGame = async (body) => {
  let res = await axios.post(
    process.env.REACT_APP_BACKEND_URL + `api/games`,
    { data: body },
    getAuthorizationHeader()
  );

  return res.data.data;
};

export const deleteGame = async (id) => {
  let res = await axios.delete(
    process.env.REACT_APP_BACKEND_URL + `api/games/${id}`,
    getAuthorizationHeader()
  );
  return res;
};

export const putGame = async (id, data) => {
  let res = await axios.put(
    process.env.REACT_APP_BACKEND_URL + `api/games/${id}`,
    { data: data },
    getAuthorizationHeader()
  );
  return res;
};

export const gameCall = async (game) => {
  await axios.post(
    process.env.REACT_APP_BACKEND_URL + `api/game-call`,
    { game: game },
    getAuthorizationHeader()
  );
  return;
};

export const getCurrentSeasonPlayerStatistics = async (playerId) => {
  const query = qs.stringify(
    {
      filters: {
        players: {
          id: {
            $in: [+playerId],
          },
        },
        season: {
          $eq: config.CURRENT_SEASON,
        },
      },
    },
    {
      encodeValuesOnly: true, // prettify URL
    }
  );

  let res = await axios.get(
    process.env.REACT_APP_BACKEND_URL + `api/games?${query}`,
    getAuthorizationHeader()
  );

  return res.data.data;
};
